<template>
  <v-card>
    <v-card-text>
      <h2>Name</h2>
      <template v-if="!editNameFlag">
        <span v-if="entity.personName" class="entityName">{{
          nameFormatted(entity.personName.combined, "full")
        }}</span>
        <span v-if="!entity.personName">Not set</span>
        &#160;
        <a @click="editName">Change</a>
      </template>
      <div class="ajaxForm" v-if="editNameFlag">
        <v-select
          :items="titles"
          v-model="personNameCopy.title"
          label="Title"
        />
        <v-text-field label="Forename" v-model="personNameCopy.forename" />
        <v-text-field label="Surname" v-model="personNameCopy.surname" />
        <div>
          <v-btn @click="saveName">Save</v-btn>
          <v-btn @click="editNameFlag = false">Cancel</v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import TITLES from "@/graphql/directory/Titles";
import UPDATE_ENTITY_PERSON_NAME from "@/graphql/directory/UpdateEntityPersonName";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "Person",
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  props: ["entity"],
  apollo: {
    titles: {
      query: TITLES,
      context: { clientName: "open" },
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    title() {
      const title = this.entity.personName
        ? nameFormatted(this.entity.personName.combined, "index")
        : this.$route.params.id;
      return title;
    }
  },
  data() {
    return {
      personName: null,
      personNameCopy: null,
      editNameFlag: false
    };
  },
  methods: {
    nameFormatted,
    editName() {
      this.personNameCopy = JSON.parse(JSON.stringify(this.entity.personName));
      this.editNameFlag = true;
    },
    async saveName() {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_PERSON_NAME,
        variables: {
          id: Number(this.$route.params.id),
          personName: this.personNameCopy
        }
      });
      this.editNameFlag = false;
      this.$emit("triggerUpdate");
    }
  }
};
</script>
